// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__BveH0","title":"card_title__2zlGR","inActive":"card_inActive__339PY"};